import React, { useMemo, useState } from 'react';
import { Store } from 'api/types/store';
import { Avatar } from 'antd';
import { IconButton, Link, Typography } from 'ui-kit';
import './Header.scss';
import { Edit3 as EditIcon } from 'react-feather';
import ShareLink from '../Share/ShareLink';
import Svg from 'react-inlinesvg';
import noPhoto from './no-photo.svg';
import EditStore from '../Store/StoreModal/Actions/EditStore';
import { mutate } from 'swr';
import { getStoreDetailsURL } from 'api/store';
import { UrlText } from 'components/UrlText';
import { getStoreLink } from 'utils/utilsV2';
import StoreIntegrationsButtonModal from 'components/Dashboard/Store/StoreIntegrationsButtonModal';

interface Props {
  store: Store;
}

export default function DashboardHeader({ store }: Props) {
  const [isEditModalOpen, setEditModalOpen] = useState(false);

  const toogleEditModal = () => {
    setEditModalOpen((prev) => !prev);
  };

  const { enterpriseInfo } = store || {};
  const { isEnabled, subdomain, isSubdomainEnabled } = enterpriseInfo ?? {};

  const storeLink = useMemo(
    () =>
      store
        ? getStoreLink({
            storeId: store.id,
            isEnabled,
            subdomain,
            isSubdomainEnabled,
          })
        : '',
    [store, isEnabled, subdomain, isSubdomainEnabled],
  );

  return (
    <section className="DashboardHeader">
      <div className="DashboardHeader-content">
        {store.image ? (
          <Avatar className="DashboardHeader-content__image" shape="circle" src={store.image} />
        ) : (
          <span className="DashboardHeader-content__no-image">
            <Svg src={noPhoto} />
          </span>
        )}
        <div className="DashboardHeader-content__details">
          <Typography variant="h3" className="DashboardHeader-content__details-title">
            {store.storeName}
            <IconButton color="primary" variant="text" onClick={toogleEditModal}>
              <EditIcon />
            </IconButton>
            {store.isSynced && <StoreIntegrationsButtonModal storeId={store.id} />}
          </Typography>
          <Typography variant="body1" className="DashboardHeader-content__details-description">
            <UrlText text={store.description} />
          </Typography>
          <Typography variant="body2" color="primary">
            <Link className="DashboardHeader-content__guest-view" href={storeLink}>
              Guest View
            </Link>
          </Typography>
        </div>
        <div className="DashboardHeader-content__links">
          <ShareLink
            variant="contained"
            className="DashboardHeader_control"
            storeId={store.id}
            color="primary"
            text="Share Store"
          />
        </div>
      </div>
      <EditStore
        isOpen={isEditModalOpen}
        store={store}
        onCancel={toogleEditModal}
        onSuccess={(store) => {
          mutate(getStoreDetailsURL(store.id));
          toogleEditModal();
        }}
      />
    </section>
  );
}
